module.exports = __webpack_public_path__ + "img/5faa68b975a5df5e8f666ea8.d957299b.png";